import React from "react";
import CircleIcon from "@mui/icons-material/Circle";

interface SelectionPanelProps {
  title: string;
  children?: React.ReactNode;
}

const SelectionPanel = (props: SelectionPanelProps) => {
  const { title, children } = props;
  return (
    <div className="dui-selection-panel">
      <div className="dui-selection-panel-title">{title}</div>
      <div className="dui-selection-panel-content">
        {children}
        <div className="dui-selection-panel-dot">
          <CircleIcon className="dui-selection-panel-dot-icon" />
        </div>
      </div>
    </div>
  );
};

export default SelectionPanel;
